import { Dropdown, Nav } from 'react-bootstrap';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { NAV_ITEMS } from '../routes';
import { useFinance } from '../financeContext';

// Finance shell: a left nav rail on >= lg, a wrapping pill bar + "More ▾" on < lg (the
// DashboardTabs behaviour, adapted to routes). Role-gated items are hidden when the actor can't
// open them.
export default function FinanceLayout() {
  const { canEditConfig } = useFinance();
  const location = useLocation();

  const items = NAV_ITEMS.filter((it) => !it.requiresEdit || canEditConfig);
  const primary = items.filter((it) => it.primary);
  const more = items.filter((it) => !it.primary);
  const activeInMore = more.some((it) => location.pathname.startsWith(it.path));

  return (
    <div className="finance-shell d-lg-flex gap-4">
      {/* >= lg rail */}
      <Nav className="flex-column d-none d-lg-flex finance-rail flex-shrink-0" style={{ width: 210 }}>
        {items.map((it) => (
          <Nav.Link key={it.path} as={NavLink} to={it.path} end={it.path === '/pending'}>
            {it.label}
          </Nav.Link>
        ))}
      </Nav>

      {/* < lg pills + More */}
      <Nav variant="pills" className="d-lg-none flex-nowrap overflow-auto mb-3 finance-pills">
        {primary.map((it) => (
          <Nav.Item key={it.path}>
            <Nav.Link as={NavLink} to={it.path} end={it.path === '/pending'}>{it.label}</Nav.Link>
          </Nav.Item>
        ))}
        {more.length > 0 && (
          <Dropdown as={Nav.Item}>
            <Dropdown.Toggle as={Nav.Link} className={activeInMore ? 'active' : undefined}>More</Dropdown.Toggle>
            <Dropdown.Menu renderOnMount popperConfig={{ strategy: 'fixed' }}>
              {more.map((it) => (
                <Dropdown.Item key={it.path} as={NavLink} to={it.path}>{it.label}</Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </Nav>

      <div className="flex-grow-1" style={{ minWidth: 0 }}>
        <Outlet />
      </div>
    </div>
  );
}
